"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var use_context_selector_1 = require("use-context-selector");
var context_1 = tslib_1.__importDefault(require("./context"));
/**
 * @deprecated Use Popover from Antd
 * https://ant.design/components/popover/
 */
function usePopover() {
    var openedTarget = (0, use_context_selector_1.useContextSelector)(context_1.default, function (context) { return context.openedTarget; });
    var popoverRef = React.useRef(null);
    var targetRef = React.useRef(null);
    var contentRef = React.useRef(null);
    var openPopover = React.useCallback(function () { var _a; return (_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.open(); }, []);
    var closePopover = React.useCallback(function () { var _a; return (_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.close(); }, []);
    return {
        openPopover: openPopover,
        closePopover: closePopover,
        isPopoverOpened: targetRef.current && openedTarget === targetRef.current,
        popoverProps: { ref: popoverRef, targetRef: targetRef, contentRef: contentRef },
        popoverTargetProps: { ref: targetRef }
    };
}
exports.default = usePopover;
